'use client'

import { useCallback } from 'react'

import {
  AdKind,
  AdPlatform,
  clickAdEvent,
  ClickAdEventTarget,
  VanPlacementConfigModel,
} from '@marketplace-web/ads/ads-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import { getAdPlacementId } from '../../components/Advertisement/utils'

const useClickAdEventTracking = () => {
  const { track } = useTracking()
  const isClickAdTrackingEnabled = useFeatureSwitch('web_van_offer_click_ad_tracking')

  const trackClickAdEvent = useCallback(
    (placement: VanPlacementConfigModel | null, target: ClickAdEventTarget) => {
      if (placement?.correlationId && placement.id && isClickAdTrackingEnabled) {
        track(
          clickAdEvent({
            placementId: getAdPlacementId(placement),
            target,
            isMobileWeb: placement.platform === AdPlatform.Mobile,
            countryCode: placement.countryCode,
            creativeId: placement.kind === AdKind.Van ? placement.creative?.id : undefined,
            campaignId: placement.id,
            correlationId: placement.correlationId,
          }),
        )
      }
    },
    [track, isClickAdTrackingEnabled],
  )

  return { trackClickAdEvent }
}

export default useClickAdEventTracking
